"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSetDefaultInvitationTypeEffect = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _invitationType = require("../CreateGift/store/gift/invitationType/invitationType.actions");

var _invitationType2 = require("../CreateGift/store/gift/invitationType/invitationType.selectors");

var useSkipStepOnInvitationWithoutAddressEffect = function useSkipStepOnInvitationWithoutAddressEffect() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var invitationTypes = (0, _reactRedux.useSelector)(_invitationType2.getAvailableInvitationTypes);
  var isAddressRequired = (0, _reactRedux.useSelector)(_invitationType2.getIsInvitationTypeRequiresAddress);
  var selectedInvitationType = (0, _reactRedux.useSelector)(_invitationType2.getSelectedInvitationTypeId);
  var isSkipStep = invitationTypes.length === 1 && !isAddressRequired && selectedInvitationType;
  (0, _react.useEffect)(function () {
    if (isSkipStep) {
      dispatch((0, _invitationType.saveInvitationType)({
        deliveryAddress: null,
        returnAddress: null
      }));
    }
  }, [dispatch, isSkipStep]);
};

var useSetDefaultInvitationTypeEffect = function useSetDefaultInvitationTypeEffect() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var selectedInvitationType = (0, _reactRedux.useSelector)(_invitationType2.getSelectedInvitationTypeId);
  var defaultInvitationType = (0, _reactRedux.useSelector)(_invitationType2.getDefaultInvitationType);
  useSkipStepOnInvitationWithoutAddressEffect();
  (0, _react.useEffect)(function () {
    if (defaultInvitationType && defaultInvitationType.id && !selectedInvitationType) {
      dispatch((0, _invitationType.selectInvitationTypeId)(defaultInvitationType.id));
    }
  }, [defaultInvitationType, selectedInvitationType, dispatch]);
};

exports.useSetDefaultInvitationTypeEffect = useSetDefaultInvitationTypeEffect;